import { Expose } from "class-transformer";
import { IsNumber, IsOptional, IsString } from "class-validator";

export class DocumentServiceItem {
  @IsString()
  @Expose()
  id!: string; // "4db4111e-f937-466c-bf66-f468418c7cf3",
  @IsString()
  @Expose()
  name!: string; // "Usługa EMD do biletu transkontynentalnego 628-1862238338 HOVHANNISYAN ERYK ",
  @IsNumber()
  @Expose()
  quantity!: number; // 1,
  @IsNumber()
  @Expose()
  netPrice!: number; //226,
  @IsNumber()
  @Expose()
  netPriceInCurrency!: number; //226,
  @IsNumber()
  @Expose()
  netValue!: number; // 226,
  @IsNumber()
  @Expose()
  netValueInCurrency!: number; //226,
  @IsNumber()
  @Expose()
  vatAmount!: number; // 0,
  @IsNumber()
  @Expose()
  vatAmountInCurrency!: number; // 0,
  @IsNumber()
  @Expose()
  gross!: number; // 226,
  @IsNumber()
  @Expose()
  grossInCurrency!: number; // 226,
  @IsOptional()
  @IsNumber()
  @Expose()
  serviceTypeId!: number | null; // null,
  @IsString()
  @Expose()
  vat!: string; //"0",
  @IsNumber()
  @Expose()
  netto!: number; // 0,
  @IsOptional()
  @IsString()
  @Expose()
  unit!: string | null;
  @IsNumber()
  @Expose()
  modifier!: number;
}

export type DocumentServicesListResponse = Array<DocumentServiceItem>;
